import ToDoTodayAdmin from "../../admin/TodoToday/toDoTodayAdmin";

export default function ToDoToday() {
  return <ToDoTodayAdmin />;
}